import styled from 'styled-components'
import { flatButton } from './shared.styles'
import { darkOrange, orange, black, white, border1 } from '@/theme/colors'
import { radii, motion } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'

export const TileWrap = styled.div`
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
	margin-top: 12px;
`

export const TileButton = styled.button`
	${flatButton}
	width: 56px;
	height: 56px;
	border-radius: ${radii.inner};
	background: ${orange};
	color: ${white};
	display: flex;
	align-items: center;
	justify-content: center;
	${text.heading}
	transition: background-color ${motion.fast};

	&:hover {
		background: ${darkOrange};
	}
`

export const TileCode = styled.span`
	${text.labelSm}
	color: ${black};
`

/** Search field pinned to the top of the (scrolling) currency list. */
export const PickerSearch = styled.input`
	position: sticky;
	top: 0;
	width: 100%;
	padding: 12px 16px;
	border: none;
	border-bottom: 1px solid ${border1};
	background: ${white};
	font-size: ${fontSizes.small};
	outline: none;
`
